import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { CreateData, getalltagsdata } from '../../Tags/TagSlice/TagsSlices'
import { TwitterPicker } from 'react-color'

const TagPopupModal = ({ show, handleClose, setSelectedTag, selectedTag, isAdmin = false }: any) => {
  const dispatch = useDispatch()
  const [tagName, setTagName] = useState('')
  const [tagColor, setTagColor] = useState('#7bdcb5')
  const [error, setError] = useState('')
  const handleCreate = () => {
    // const newArr = [...selectedTag, {value: tagName, label: tagName}]?.filter(
    //   (key) => key?.value !== ''
    // )
    dispatch(
      CreateData({
        name: tagName,
        isAdmin: isAdmin
      })
    )

    handleClose()
    // setSelectedTag(newArr)
    setTagName('')
    dispatch(getalltagsdata())
  }

  const handleChangeColor = (color: any) => {
    setTagColor(color.hex)
  }

  return (
    <>
      <Modal
        backdrop='static'
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-550px'
        className='vh-100'
        show={show}
        onHide={handleClose}
      >
        <>
          <div className='modal-header'>
            <h1>Create new tag</h1>
          </div>
          <div className='modal-body'>
            <label className='w-100'>
              <span
                style={{
                  color: '#5F6276',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
              >
                Tag name
              </span>
              <input
                onBlur={() => {
                  ; /^[a-zA-Z0-9_ -]{2,25}$/.test(tagName)
                    ? setError('')
                    : setError('please enter valid tag ')
                }}
                placeholder='Tag name'
                maxLength={25}
                className='form-control form-control-solid border-0 w-100 mt-2'
                onChange={(e: any) => {
                  setError('')
                  setTagName(e.target.value)
                }}
              />
              {tagName && (
                <>
                  <label className=' col-form-label required fw-bold fs-6'>Color</label>
                  <div
                    className='form-control form-control-lg form-control-solid mb-3 mb-lg-0 text-white'
                    style={{ backgroundColor: tagColor }}
                  >
                    {tagName}
                  </div>

                  <TwitterPicker onChange={handleChangeColor}
                    triangle='hide'
                    colors={['#D9E3F0', '#F47373', '#697689', '#37D67A', '#2CCCE4', '#555555', '#dce775', '#ff8a65', '#ba68c8', '#22194D']}
                  />
                </>
              )}
              <span className='text-danger mt-1'>{error}</span>
              <span
                style={{
                  color: '#a1a5b7',
                  fontSize: '12px',
                  fontWeight: '500',
                  textAlign: 'left',
                }}
              >
                Tag name must consist of; Alphanumeric characters and underscores. Max length 25
                characters with no spaces.
              </span>
            </label>
          </div>
          <div className='modal-footer w-100'>
            <button onClick={handleClose} type='button' className='btn btn-light-primary'>
              Cancel
            </button>
            <button
              disabled={error !== '' || tagName == ''}
              onClick={handleCreate}
              id='submit'
              type='button'
              className='btn btn-primary w-50 '
            >
              Create tag
            </button>
          </div>
        </>
      </Modal>
    </>
  )
}

export default TagPopupModal
